export const AIBOXAPPID = 'd320d30a9da594d7ed4930853e0e890b';

export const ICON_PATH = 'https://stc.yxt.com/ufd/3f5568/yxtbiz/pc/svg';

export const HIGHLIGHT_TAG = {
  start: '(~esTagStart~)',
  end: '(~esTagEnd~)'
};
